import { Fieldset, Grid, Select, TextInput } from '@mantine/core';
import type { UseFormReturnType } from '@mantine/form';
import { IconUsersGroup } from '@tabler/icons-react';
import { useParams } from 'react-router-dom';
import { FormGenericSelector } from '../../../components/form/FormGenericSelector';
import { defaultIconStyle } from '../../../theme/styling/iconStyling';

interface UpsertDepartmentFormProps<T> {
	form: UseFormReturnType<T, (values: T) => T>;
}

export function UpsertDepartmentForm<T>({
	form,
}: UpsertDepartmentFormProps<T>) {
	const { organisation } = useParams();

	return (
		<>
			<Fieldset>
				<Grid>
					<Grid.Col>
						<TextInput
							label={'Department Name'}
							placeholder={'Insert name of new department...'}
							key={form.key('departmentName')}
							{...form.getInputProps('departmentName')}
						/>
					</Grid.Col>
					<Grid.Col>
						<FormGenericSelector
							label={'Group'}
							placeholder={'Select group...'}
							icon={<IconUsersGroup {...defaultIconStyle} />}
							form={form}
							property={'groupId'}
							apiRoute={`${organisation}/groups/options`}
						/>
					</Grid.Col>
					<Grid.Col>
						<Select
							label={'Should Display'}
							placeholder={'Choose whether should display...'}
							data={['True', 'False']}
							key={form.key('shouldDisplay')}
							{...form.getInputProps('shouldDisplay')}
						/>
					</Grid.Col>
				</Grid>
			</Fieldset>
		</>
	);
}
